import withApollo from 'next-with-apollo';
import { ApolloClient, ApolloProvider, InMemoryCache, createHttpLink } from '@apollo/client';
import appConfig from '../../config/appConfig';

export default withApollo(
  ({ initialState, headers }: any) => {
    const isBrowser = typeof window !== 'undefined';
    return new ApolloClient({
      connectToDevTools: isBrowser,
      ssrMode: !isBrowser,
      link: createHttpLink({
        uri: process.env.NEXT_PUBLIC_HASURA_GRAPHQL_ENDPOINT,
        ...(!isBrowser && { fetch }),
        headers,
      }),
      cache: new InMemoryCache().restore(initialState || {}),
    });
  },
  {
    render: ({ Page, props }) => {
      return (
        <ApolloProvider client={props.apollo}>
          <Page {...props} />
        </ApolloProvider>
      );
    },
  }
);
